import React, { useState, useEffect } from 'react';
import { AUTH_ENDPOINTS } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const Auth = () => {
    const { isLoading } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const errorParam = urlParams.get('error');

        if (errorParam) {
            setError('This is a closed application. Your email needs to be invited. Please contact the administrator.');

            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [location]);

    const handleLogin = async () => {
        try {
            setLoading(true);
            window.location.href = AUTH_ENDPOINTS.getCognitoLoginUrl();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to initiate login';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (isLoading || loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
                <div>Checking authentication...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow p-8 border">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-semibold mb-2">Welcome back</h1>
                </div>
                {error && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                        <div className="flex items-center gap-2 mb-2">
                            <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium text-red-800">Access Denied</span>
                        </div>
                        <p className="text-red-700 text-sm">{error}</p>
                    </div>
                )}
                <button
                    onClick={handleLogin}
                    disabled={loading}
                    className="w-full bg-white text-gray-700 py-3 px-4 rounded-md font-medium border border-gray-300 hover:bg-gray-50 transition flex items-center justify-center gap-3"
                >
                    <ArrowRightOnRectangleIcon className="w-5 h-5" />
                    {loading ? 'Signing in...' : 'Sign in'}
                </button>
                <div className="mt-6 text-center">
                    <p className="text-xs text-gray-400">
                        By signing in, you agree to our{' '}
                        <a href="#" className="text-blue-600 hover:underline">Terms of Service</a>
                        {' '}and{' '}
                        <a href="#" className="text-blue-600 hover:underline">Privacy Policy</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Auth; 